<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<p class="centers"><a id="page_7">Fur Fact #1</a></p><a id="page_7">
<p class="noindent">Almost half of all dog owners let their dogs sleep in bed with them at night. Some pet owners don’t like it though. They think it’s best that their pets sleep in their own beds at night, just like kids sleep in their own beds.</p>
<p class="indent">But did you know that back in the old days, people in Australia slept with their dogs to keep warm? Two dogs were used for colder nights, and if it was really, really cold, it would be a “three-dog night.”</p>
<p class="indent">Those were the days when people had to sleep outside, though. And they didn’t have blankets like we do now. So if you tell your parents you need a dog to keep you warm at night, you might want to leave those last two things out of your talk.</p>
</a></div><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01b.vue?36d5e2ce